export default {
  RecruitmentDragAndDrop: {
    mounted() {
      window.recruitmentDnd = this;
    },

    dragstart(event) {
      event.dataTransfer.setData("text/plain", event.target.id);
      // Highlight all droppable zones
      document.querySelectorAll(".kanban-column").forEach((el) => {
        el.classList.add("is-highlighted");
      });
      document.querySelectorAll(".lead-status-tab").forEach((el) => {
        el.classList.add("is-highlighted");
      });
    },

    dragenter(event) {
      event.preventDefault();
    },

    dragover(event) {
      event.preventDefault();

      // Highlight dropzone
      if (event.target) {
        if (event.target.closest(".kanban-column")) {
          event.target.closest(".kanban-column").classList.add("on-dragover");
        } else if (event.target.closest(".lead-status-tab")) {
          event.target.closest(".lead-status-tab").classList.add("on-dragover");
        }
      }
    },

    dragleave(event) {
      // Remove highlight from dropzone
      if (event.target) {
        if (event.target.closest(".kanban-column")) {
          event.target
            .closest(".kanban-column")
            .classList.remove("on-dragover");
        } else if (event.target.closest(".lead-status-tab")) {
          event.target
            .closest(".lead-status-tab")
            .classList.remove("on-dragover");
        }
      }
    },

    dragend(event) {
      event.preventDefault();

      // Remove highlight from all droppable zones
      document.querySelectorAll(".kanban-column").forEach((el) => {
        el.classList.remove("is-highlighted");
      });
      document.querySelectorAll(".lead-status-tab").forEach((el) => {
        el.classList.remove("is-highlighted");
      });
    },

    drop(event) {
      event.preventDefault();

      let targetStatus;

      try {
        // Get dropzone data and remove highlight from it
        if (event.target.closest(".kanban-column")) {
          targetStatus = event.target.closest(".kanban-column");
          targetStatus.classList.remove("on-dragover");
        } else if (event.target.closest(".lead-status-tab")) {
          targetStatus = event.target.closest(".lead-status-tab");
          targetStatus.classList.remove("on-dragover");
        }

        const lead = document.getElementById(
          event.dataTransfer.getData("text/plain"),
        );

        this.updateStatus(lead, targetStatus);
      } catch {
        window.toast({
          message:
            "There was an error. We were unable perform your requested action.",
          type: "is-danger",
        });
      }
    },

    updateStatus(lead, targetZone) {
      const targetStatus = targetZone.dataset.statusId;
      const leadCurrentStatus = lead.closest(".kanban-column").dataset.statusId;

      // If moving to same Status, ignore
      if (leadCurrentStatus === targetStatus) {
        return;
      }

      // Give immediate feedback to user while we wait for a server response
      document.querySelector(".kanban").classList.add("is-loading");

      // Send event to server
      this.pushEvent("update-status", {
        lead_id: lead.id.replace("lead-", ""),
        status_id: targetStatus,
      });
    },
  },
};
